import React from 'react';
import PolicyNoticeBanner from './common/PolicyNoticeBanner';
import { SHUTDOWN_FALLBACK } from './PatientAppLanding';

function PatientPrivacy() {
    return (
        <div style={S.body}>
            <div style={S.container}>
                {/* 구 환자앱 종료 고지 — 방침 "탈퇴 시 즉시 파기"와 실제 파기 일정(10-14~10-19) 차이를 메우는 곳 (종료고지 §2-2) */}
                <PolicyNoticeBanner fallback={SHUTDOWN_FALLBACK} />
                {/* 📜 종료된 서비스 고정 표시 (2026-10-11 계획_케어앱_예약대기 W5·법무 P2-1, B7 (가)) — 구 방침의 "예약 시 … 진료 내용 전달" 문장이 현행으로 읽히지 않게.
                    종료일은 이미 공개된 종료 고지(SHUTDOWN_FALLBACK '2026년 9월 14일')와 맞춘다. config 와 무관하게 항상 보인다 */}
                <div role="note" style={{ background: '#fff7ed', border: '1px solid #fed7aa', color: '#9a3412', borderRadius: 10, padding: '12px 14px', fontSize: 14, lineHeight: 1.6, marginBottom: 16 }}>
                    <b>{'이 문서는 2026년 9월 14일 종료된 서비스(구 덴탈클러스터 환자앱)의 문서입니다.'}</b><br />
                    {'이 문서의 내용은 지금 제공하는 서비스에 적용되지 않습니다. 지금 제공하는 덴클 케어 앱의 개인정보 처리는 '}<a href="/privacy" style={{ color: '#9a3412', fontWeight: 700 }}>{'개인정보 처리방침'}</a>{'을 따릅니다.'}
                </div>
                <div style={S.header}>
                    <h1 style={S.title}>환자 개인정보처리방침</h1>
                    <p style={S.meta}>버전 v1.0 · 시행일 2026-05-01</p>
                </div>

                <section style={S.section}>
                    <p style={S.intro}>
                        주식회사 덴탈클러스터(이하 "회사")는 환자 회원의 개인정보를 매우 중요시하며,
                        「개인정보 보호법」 및 관계 법령을 준수합니다.
                    </p>

                    <h2 style={S.h2}>1. 수집하는 개인정보 항목</h2>
                    <p style={S.p}>
                        <strong>[필수 항목]</strong>
                        <br />- 이름, 생년, 성별
                        <br />- 휴대폰 번호 (인증 및 알림 발송)
                        <br />- 카카오·네이버 계정 식별자 (소셜 로그인 시)
                        <br /><br />
                        <strong>[선택 항목]</strong>
                        <br />- 이메일 주소
                        <br />- 거주 지역(시/구)
                        <br />- 보험 가입 정보 (혜택 추천용)
                        <br />- 가족 구성원 정보 (이름·관계·생년)
                        <br /><br />
                        <strong>[자동 수집]</strong>
                        <br />- 단말기 정보, IP 주소, 접속 로그
                        <br />- 위치 정보 (앱 내 동의 후)
                        <br /><br />
                        <strong>[의료 자료 - 회원이 직접 업로드]</strong>
                        <br />- 영수증 이미지·PDF
                        <br />- X-ray 사진
                        <br />- 처방전
                        <br />- 진료 메모
                    </p>

                    <h2 style={S.h2}>2. 개인정보 수집·이용 목적</h2>
                    <p style={S.p}>
                        - 회원 식별 및 본인 인증<br />
                        - 의료기관 검색 및 예약 정보 전달<br />
                        - 검진·치료 권장 정보의 맞춤 제공<br />
                        - 의료 자료 보관 (회원 본인 참고용)<br />
                        - 연말정산·보험 청구 자료 자동 정리 지원<br />
                        - 가족 구성원 검진 시기 알림<br />
                        - 서비스 이용 통계 분석 및 개선<br />
                        - 법령상 의무 이행
                    </p>

                    <h2 style={S.h2}>3. 개인정보 보유 및 이용 기간</h2>
                    <p style={S.p}>
                        ① 회사는 회원의 개인정보를 회원 탈퇴 시까지 보관하며, 탈퇴 시 즉시 파기합니다.<br />
                        ② 단, 다음 각 호에 해당하는 정보는 관련 법령에 따라 보존됩니다.<br />
                        - 이용 계약 또는 청약 철회 등에 관한 기록: 5년 (전자상거래법)<br />
                        - 결제 및 재화 등의 공급에 관한 기록: 5년 (전자상거래법)<br />
                        - 소비자의 불만 또는 분쟁 처리에 관한 기록: 3년 (전자상거래법)<br />
                        - 접속 로그 기록: 3개월 (통신비밀보호법)
                    </p>

                    <h2 style={S.h2}>4. 의료 자료의 별도 보호</h2>
                    <p style={S.p}>
                        ① 회원이 업로드한 영수증·X-ray·처방전 등 의료 관련 자료는 회원 본인 외 누구도 접근할 수 없습니다.<br />
                        ② 회사는 의료 자료를 분석·가공·제3자 제공·마케팅 활용에 사용하지 않습니다.<br />
                        ③ 의료 자료는 별도 암호화 저장소(Firebase Storage)에 보관되며, 회원 본인 인증을 거쳐야만 접근 가능합니다.<br />
                        ④ 회원은 언제든지 자료를 삭제할 수 있으며, 탈퇴 시 즉시 영구 삭제됩니다.
                    </p>

                    <h2 style={S.h2}>5. 개인정보 제3자 제공</h2>
                    <p style={S.p}>
                        ① 회사는 회원의 동의 없이 개인정보를 제3자에게 제공하지 않습니다.<br />
                        ② 단, 다음의 경우 예외로 합니다.<br />
                        - <strong>예약 시</strong>: 회원이 선택한 의료기관에 한하여 예약에 필요한 최소 정보(이름·연락처·예약 일시·간단한 진료 내용)를 전달합니다.<br />
                        - 법령상 의무가 있는 경우<br />
                        - 회원의 명시적 동의가 있는 경우
                    </p>

                    <h2 style={S.h2}>6. 개인정보 처리 위탁</h2>
                    <p style={S.p}>
                        회사는 서비스 제공을 위해 다음과 같이 개인정보 처리를 위탁할 수 있습니다.<br />
                        - Google Firebase (Authentication·Firestore·Storage·Cloud Functions·FCM): 인증·데이터 저장·알림<br />
                        - 카카오·네이버 (소셜 로그인 시): 본인 인증<br />
                        - 카카오모빌리티 (지도): 위치·주소 검색<br />
                        - Google Cloud Vision (선택): 영수증 OCR<br />
                        모든 위탁 업체는 「개인정보 보호법」을 준수합니다.
                    </p>

                    <h2 style={S.h2}>7. 회원의 권리</h2>
                    <p style={S.p}>
                        회원은 언제든지 다음 권리를 행사할 수 있습니다.<br />
                        - 개인정보 열람·수정·삭제 요청<br />
                        - 개인정보 처리 정지 요청<br />
                        - 회원 탈퇴 (앱·웹 내 설정에서 즉시 가능)<br />
                        - 동의 철회 (선택 항목에 한함)<br />
                        권리 행사: 앱 내 [설정 → 계정] 또는 고객센터(privacy@dentalcluster.com)
                    </p>

                    <h2 style={S.h2}>8. 만 14세 미만 아동의 개인정보</h2>
                    <p style={S.p}>
                        ① 본 서비스는 만 14세 이상만 회원가입할 수 있습니다.<br />
                        ② 만 14세 미만 자녀의 정보는 법정대리인(부모)이 가족 구성원 추가 기능을 통해 입력할 수 있으며, 법정대리인의 동의를 거친 것으로 간주합니다.<br />
                        ③ 자녀 정보는 검진 시기 안내 등 보호자에게 정보 제공 목적으로만 사용됩니다.
                    </p>

                    <h2 style={S.h2}>9. 개인정보 안전성 확보 조치</h2>
                    <p style={S.p}>
                        - 개인정보 암호화 (HTTPS·전송 구간 암호화, 비밀번호 단방향 해시)<br />
                        - 의료 자료 별도 암호화 저장<br />
                        - 접근 권한 최소화 및 접근 통제<br />
                        - 접속 기록 보관 및 모니터링<br />
                        - 정기적 보안 점검
                    </p>

                    <h2 style={S.h2}>10. 쿠키·자동 수집 정보</h2>
                    <p style={S.p}>
                        회사는 서비스 개선·로그인 유지를 위해 쿠키 및 유사 기술을 사용할 수 있습니다.
                        회원은 브라우저·앱 설정에서 거부할 수 있으나, 일부 기능 이용에 제한이 있을 수 있습니다.
                    </p>

                    <h2 style={S.h2}>11. 개인정보 보호책임자</h2>
                    <p style={S.p}>
                        성명: (지정 예정)<br />
                        이메일: privacy@dentalcluster.com<br />
                        전화: 010-2972-3733
                    </p>

                    <h2 style={S.h2}>12. 권익 침해 구제 방법</h2>
                    <p style={S.p}>
                        - 개인정보 분쟁조정위원회: privacy.go.kr / 1833-6972<br />
                        - 개인정보침해 신고센터: privacy.kisa.or.kr / 118<br />
                        - 대검찰청 사이버수사과: 02-3480-3573<br />
                        - 경찰청 사이버수사국: ecrm.cyber.go.kr / 182
                    </p>

                    <h2 style={S.h2}>13. 개인정보처리방침의 변경</h2>
                    <p style={S.p}>
                        본 방침의 내용 변경 시 시행일 7일 전(중요 사항은 30일 전) 공지합니다.
                    </p>

                    <p style={S.lastUpdate}>
                        시행일: 2026년 5월 1일<br />
                        주식회사 덴탈클러스터
                    </p>
                </section>
            </div>
        </div>
    );
}

const S = {
    body: { backgroundColor: '#f8fafc', minHeight: '100vh', fontFamily: "'Apple SD Gothic Neo', 'Malgun Gothic', sans-serif", color: '#0f172a', padding: '40px 20px' },
    container: { maxWidth: 760, margin: '0 auto', backgroundColor: '#fff', padding: '40px', borderRadius: 14, border: '1px solid #e2e8f0' },
    header: { textAlign: 'center', marginBottom: 32, paddingBottom: 20, borderBottom: '2px solid #0ea5e9' },
    title: { fontSize: 26, fontWeight: 900, margin: '0 0 6px' },
    meta: { fontSize: 12, color: '#64748b' },
    section: { lineHeight: 1.8 },
    intro: { fontSize: 13.5, color: '#334155', marginBottom: 24, padding: 14, background: '#f0f9ff', border: '1px solid #bae6fd', borderRadius: 8 },
    h2: { fontSize: 16, fontWeight: 800, marginTop: 28, marginBottom: 8 },
    p: { fontSize: 13.5, color: '#334155', whiteSpace: 'pre-line', marginBottom: 6 },
    lastUpdate: { textAlign: 'right', marginTop: 40, fontSize: 12, color: '#64748b', borderTop: '1px solid #e2e8f0', paddingTop: 16 },
};

export default PatientPrivacy;
